var _defs, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUspBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 451.1 582.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uspborder1{fill:url(#Naamloos_verloop_98);}.uspborder1,.uspborder2{opacity:.76;}.uspborder2{fill:url(#Naamloos_verloop_98-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_98",
    x1: 0,
    y1: 291.35,
    x2: 451.1,
    y2: 291.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bb00f9",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4649ff",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_98-2",
    x1: 30.56,
    x2: 420.53,
    xlinkHref: "#Naamloos_verloop_98"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "uspborder1",
    width: 451.1,
    height: 582.69,
    rx: 5.41,
    ry: 5.41
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "uspborder2",
    x: 30.56,
    y: 27.9,
    width: 389.97,
    height: 526.88,
    rx: 5.41,
    ry: 5.41
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUspBorder);
export default __webpack_public_path__ + "static/media/UspBorder.d780b1aff1e62382d4d4f3a2807f6c0d.svg";
export { ForwardRef as ReactComponent };